import { render } from "./Qna.vue?vue&type=template&id=b198795e"
import script from "./Qna.vue?vue&type=script&lang=js"
export * from "./Qna.vue?vue&type=script&lang=js"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__